<template>
  <div id="settings-wrapper">
    <transition>
      <v-btn
        v-show="scY > 300"
        fab
        small
        color="white"
        elevation="3"
        class="scroll-top-btn"
        @click="toTop"
      >
        <v-icon color="#2b6cb0">mdi-chevron-up</v-icon>
      </v-btn>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DashboardCoreSettings",

  data: () => ({
    scTimer: 0,
    scY: 0
  }),

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll: function () {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped>
#settings-wrapper {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 6;
}

.scroll-top-btn {
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}
</style>
